import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import type { UserAction } from './actions';
import {
  GET_ADS_ACTIVITY_CONFIG,
  GET_ROLE,
  GET_USER,
  UPDATE_ADS_ACTIVITY_CONFIG,
  UPDATE_USER,
  UPDATE_USER_SETTINGS,
} from './actions';
import { INIT_STATE } from './constants';
import type { UserState } from './types';

const Handler = (state: WrappedReducer<UserState>, action: UserAction): WrappedReducer<UserState> => {
  switch (action.type) {
    case GET_USER.response:
    case UPDATE_USER.response:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.data,
      };
    case UPDATE_USER_SETTINGS.request:
      return {
        ...state,
        settingsLoading: true,
        error: null,
      };
    case UPDATE_USER_SETTINGS.response:
      return {
        ...state,
        settingsLoading: false,
        error: null,
        data: action.data,
      };

    case GET_ROLE.response:
      return {
        ...state,
        loading: false,
        error: null,
        access_role_id: action.data && action.data.access_role_id,
      };

    case GET_ADS_ACTIVITY_CONFIG.response: {
      return {
        ...state,
        adsActivityConfig: action.data,
      };
    }

    case GET_ADS_ACTIVITY_CONFIG.response:
    case UPDATE_ADS_ACTIVITY_CONFIG: {
      return {
        ...state,
        adsActivityConfig: action.data,
      };
    }

    default:
      return state;
  }
};

const User = ReduxAsyncActionsService.wrapReducer(INIT_STATE, Handler, {
  request: [GET_USER, GET_ROLE, UPDATE_USER],
  error: [GET_USER, GET_ROLE, UPDATE_USER],
  resetOn: ['APP_CHANGE'],
});

export default User;
